import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import { MatDialogModule } from '@angular/material/dialog'
import { ThirdPartyNoticeComponent } from './components/legal/third-party-notice-dialog/third-party-notice-dialog.component'
import { PhxAuthLoadingComponent } from './components/system/phx-auth-loading/phx-auth-loading.component'

@NgModule({
  declarations: [ThirdPartyNoticeComponent, PhxAuthLoadingComponent],
  imports: [CommonModule, HttpClientModule, MatDialogModule],
  exports: [ThirdPartyNoticeComponent, PhxAuthLoadingComponent],
})
export class PhxAngularMaterialModule {}
